<template>
  <div class="h-full overflow-hidden">
    <el-table
      :data="specialPersonalData"
      border
      stripe
      class="mt-20px"
      :height="tableHeight"
      row-key="unique"
      :tree-props="{
        children: 'allCertificates',
        hasChildren: 'hasChildren',
      }"
    >
      <el-table-column type="index" label="序号" width="60" show-overflow-tooltip></el-table-column>
      <el-table-column label="姓名" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column label="年龄" prop="age" show-overflow-tooltip></el-table-column>
      <el-table-column label="学历" prop="educationName" show-overflow-tooltip></el-table-column>
      <el-table-column label="工种类型" prop="jobsName" show-overflow-tooltip></el-table-column>
      <el-table-column label="证书有效期" prop="validDate" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.validDate ? dayjs(scope.row.validDate).format('YYYY-MM-DD') : '' }}
        </template>
      </el-table-column>
      <el-table-column label="证书编号" prop="serialNumber" show-overflow-tooltip></el-table-column>
      <!-- <el-table-column label="发证机关" prop="education" show-overflow-tooltip></el-table-column> -->
      <el-table-column
        label="岗位"
        prop="personnelCategoryName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="gotoDetail(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="specialPersonalTableSizeChange"
      @current-change="specialPersonalableCurrentChange"
      :current-page.sync="specialPersonalPageConfig.SkipCount"
      :page-size.sync="specialPersonalPageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="specialPersonalPageConfig.total"
      class="float-right mt-20px ml-20px clear-both"
    ></el-pagination>
  </div>
</template>
<script>
import { ContractorPersonnelApi } from '@wiz-api/contractor-management'
import utils from '@/components/safety/enumField/utils'

const contractorPersonnelApi = new ContractorPersonnelApi()
export default {
  data() {
    return {
      dutieJobList: [],
      jobList: [],
      educationList: [],
      specialPersonalData: [],
      specialPersonalPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
        total: 0,
      },
    }
  },
  props: {
    contractorId: {
      type: String,
      default: '',
    },
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 75px)'
    },
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  async created() {
    await utils.getDataCategory(
      [
        'ContractorManagement.DataCategory.Education',
        'ContractorManagement.DataCategory.Jobs',
        'ContractorManagement.DataCategory.DutieJob',
      ],
      ['educationList', 'jobList', 'dutieJobList'],
      this
    )
    this.getData()
  },
  methods: {
    // 奖励考核信息页码改变
    specialPersonalTableSizeChange(MaxResultCount) {
      this.rewardsAndAssessment.MaxResultCount = MaxResultCount
      this.getData()
    },
    // 奖励考核信息页数改变
    specialPersonalableCurrentChange(SkipCount) {
      this.rewardsAndAssessmentPageConfig.SkipCount = SkipCount
      this.getData()
    },
    async getData() {
      const data = {
        contractorId: this.contractorId,
        maxResultCount: this.specialPersonalPageConfig.MaxResultCount, // 每页多少条
        skipCount:
          (this.specialPersonalPageConfig.SkipCount - 1) *
          this.specialPersonalPageConfig.MaxResultCount, // 跳过多少条
        isSpecialOperationCertificatePersonnel: true,
      }
      const [err, res] = await contractorPersonnelApi.pagedListQuery(data)
      if (!err) {
        this.specialPersonalData = res.items.map((item, index) => {
          this.educationList.forEach((e) => {
            if (item.education === parseInt(e.code, 10)) {
              item.educationName = e.displayName
            }
          })
          this.jobList.forEach((e) => {
            if (item.jobs === parseInt(e.code, 10)) {
              item.jobsName = e.displayName
            }
          })
          this.dutieJobList.forEach((e) => {
            if (item.dutieJob === parseInt(e.code, 10)) {
              item.personnelCategoryName = e.displayName
            }
          })
          item.unique =
            item.id +
            (this.specialPersonalPageConfig.SkipCount - 1) *
              this.specialPersonalPageConfig.MaxResultCount +
            index
          const arr = item.specialPersonnelCertificates.map((certificate, certificateIndex) => {
            certificate = {
              ...certificate,
              ...item,
            }
            certificate.unique =
              item.id +
              (this.specialPersonalPageConfig.SkipCount - 1) *
                this.specialPersonalPageConfig.MaxResultCount +
              certificateIndex +
              1
            delete certificate.specialPersonnelCertificates
            return certificate
          })
          item.allCertificates = arr
          return item
        })
        this.specialPersonalPageConfig.totalCount = res.totalCount
      }
    },
    gotoDetail(row) {
      this.$router.push({
        path: `${this.basePath}/contractor-management-sm/personnel-configuration`,
        query: {
          id: row.id,
          pageFrom: 'OneBookOneTeam',
        },
      })
    },
  },
}
</script>
